import Goal from "../model2/goal/goal"
import {modalCopyGoal} from "./copy/copy"

export default class GoalModalsManager {
    duplicate(goal: Goal, callback: func) {
        modalCopyGoal(goal, {
            callback
        })
    }
}
